import React, {useCallback, useContext} from "react";
import {BookingHeader} from "../BookingHeader";
import {AppContext} from "../../../AppContext";
import {PageLoader} from "../../../components";
import {MarketplaceContext} from "../../marketplaceContext";
import "../marketplace-booking.css";
import {ProductBookingContext, ProductBookingContextProvider} from "./ProductBookingContext.jsx";
import {ProductBookingForm} from "./ProductBookingForm.jsx";
import {MarketplaceOrderPreview} from "../MarketplaceOrderPreview.jsx";
import {OrderFormPanelKeys} from "../../consts.jsx";
import {updateMeCompanyFinanceContact} from "../../../api/company/index.jsx";

export const ProductBookingWrapper = ({history}) => {
    const {me, company, planBudgetOrder, setPlanBudgetOrder, services, fetchMe, fetchCompany} = useContext(AppContext);

    const onSaveMeCompanyFinanceContact = useCallback(
        async financeContact => {
            await updateMeCompanyFinanceContact(me, financeContact);
        },
        [me]
    );

    return (
        <ProductBookingContextProvider
            history={history}
            me={me}
            company={company}
            services={services}
            planBudgetOrder={planBudgetOrder}
            fetchMe={fetchMe}
            fetchCompany={fetchCompany}
            onSaveCompanyFinanceContact={onSaveMeCompanyFinanceContact}
            setPlanBudgetOrder={setPlanBudgetOrder}>
            <ProductBooking />
        </ProductBookingContextProvider>
    );
};

export const ProductBooking = () => {
    const {me, company} = useContext(AppContext);
    const {product, providerDetails} = useContext(MarketplaceContext);

    const {
        log,
        saveProductAsDraft,
        setUpdateDetailsModals,
        sendOrderAsQuote,
        onFinishClick,
        bookingLoading,
        bookingError,
        formValues,
        offeredPrice,
        coupon,
        couponDiscountAmount,
        setCouponCode,
        onCancelCoupon,
        deliveryPrice,
        loadingDeliveryPrice,
        upgradeOptionsPrice,
        tip
    } = useContext(ProductBookingContext);

    return (
        <>
            {product ? (
                <>
                    <div className="booking-container">
                        <div className="booking-container-width">
                            <BookingHeader
                                productName={product?.productName}
                                isVoucherProvider={providerDetails?.isVoucherProvider}
                                log={log}
                                saveProductAsDraft={saveProductAsDraft}
                                setUpdateDetailsModals={setUpdateDetailsModals}
                                sendOrderAsQuote={sendOrderAsQuote}
                            />

                            <div className="booking-container-wrapper">
                                <div className="booking-container-content">
                                    <MarketplaceOrderPreview
                                        me={me}
                                        company={company}
                                        onFinishClick={onFinishClick}
                                        bookingLoading={bookingLoading}
                                        canFinish={!bookingError}
                                        content={product}
                                        formValues={formValues}
                                        offeredPrice={offeredPrice}
                                        coupon={coupon}
                                        couponDiscountAmount={couponDiscountAmount}
                                        onCouponAdded={setCouponCode}
                                        onCancelCoupon={onCancelCoupon}
                                        deliveryPrice={deliveryPrice}
                                        loadingDeliveryPrice={loadingDeliveryPrice}
                                        upgradeOptionsPrice={upgradeOptionsPrice}
                                        companyDiscount={formValues.companyDiscount}
                                        tip={tip}
                                        bookingError={bookingError}
                                    />
                                    <ProductBookingForm readOnlyFields={[OrderFormPanelKeys.UpgradeOptionsCustom]} />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <PageLoader style={{top: "80px"}} />
            )}
        </>
    );
};
